@if (!_lifestyle) {
<div class="loading">{{'common.loading' | translate}}</div>
}
<div class="bg-e-white md:px-[100px]">
  <div class="container-default pt-[50px]">
    <div class="flex flex-col-reverse md:flex-row">
      <div class="w-full md:w-1/3 md:min-h-[500px] p-6 md:p-0">
        <h1 class="mb-5 md:my-5 text-left" itemprop="name">{{_lifestyle?.title}}</h1>
        <div class="" [innerHTML]="_lifestyle?.shortdescription | safeHtml"></div>

        <div class="flex flex-row items-center my-5">
          <small class="font-bold w-1/3">{{'common.person' | translate}}</small>
          <app-personselection class="w-2/3" [colorscheme]="'white'" [persons]="this.persons.value" (personsChange)="changePersonQty($event)"></app-personselection>
        </div>
        <div class="flex flex-row items-center mb-5">
          <small class="font-bold w-1/3">{{'common.meal' | translate}}</small>
          <app-quantityselection class="w-2/3" colorscheme="white" [quantity]="meals.value" (quantityChange)="changeMealQty($event)" [min]="_globalService.minSubscriptionMeals" [max]="_globalService.maxSubscriptionMeals"></app-quantityselection>
        </div>
        @if (authService.isAuthenticatedValue === false) {
        <div class="flex flex-row justify-center p-[15px] rounded-md min-w-[300px]">
          <button (click)="chooseLifestyle()" class="button-base rounded-full w-full md:w-[200px]" id="chooselifestyle">
            <span>{{'lifestyle.choose_this_lifestyle' | translate}}</span>
          </button>
        </div>
        }
      </div>
      <div class="pt-6relative md:ml-[50px] w-full md:w-2/3 md:min-h-[500px]">
        <div class="flex rounded-3xl overflow-hidden min-h-[300px] h-full">
          @if (!!imageRecipes) {
          <app-image  size="lg" [imageobject]="imageRecipes[0]" class="max-h-[600px] object-cover w-full rounded-3xl"></app-image>
          }
        </div>
      </div>
    </div>

    <div class="max-w-[1020px] mx-auto mt-6 md:mt-[75px] md:p-0">
      <div class="" [innerHTML]="_lifestyle?.description | safeHtml"></div>

      @if (_lifestyle?.lifestylefaqs) {
      <div class="mt-[50px]">
        @for (faq of _lifestyle.lifestylefaqs; track $index) {
          <faq [faqid]="faq.faqid"></faq>
        }
      </div>
    }

      <div class="mt-[50px] pb-5">
        <div class="flex flex-row mb-6 items-center">
          <p class="me-6 my-0">{{ _lifestyle?.title }}</p>
          <button class="button-base rounded-full mr-[15px]" (click)="activeWeek = 'current'" [ngClass]="{'bg-white text-e-dark-green' : activeWeek !== 'current'}">
            {{'lifestyle.this_week' | translate}}
          </button>
          <button class="button-base rounded-full" (click)="activeWeek = 'nextweek'" [ngClass]="{'bg-white text-e-dark-green' : activeWeek === 'current'}">
            {{'lifestyle.next_week' | translate}}
          </button>
        </div>
        <div>
          <recipe-list [lifestyles]="[_lifestyle?.id]" [deliverydate]="activeWeek === 'current' ? dateToday : dateNextWeek" (shownRecipesChange)="setImageRecipes($event)">
            <ng-template #recipe let-recipe>
              <recipecard [recipe]="recipe" [status]="'PROCESSED'" [persons]="persons.value" (showRecipe)="showRecipe($event, 2)">
              </recipecard>
            </ng-template>
          </recipe-list>
        </div>
      </div>


    </div>
  </div>

  <lifestylechosendialog #lifestylechosendialog></lifestylechosendialog>

  <!-- template for the bottom drawer dialog -->
  <ng-template #bottomdrawer>
    <div class="flex flex-row justify-center p-[15px] rounded-lg bg-white min-w-[300px]">
      <button (click)="chooseLifestyle()" class="button rounded-full w-full md:w-[200px]" id="chooselifestyle">
        <span>{{'common.continue' | translate}}</span>
      </button>
    </div>
  </ng-template>
</div>